import {AuthenticationService} from "../services/authentication.service";
import {ERROR_MESSAGES} from "./models/models";

export function hasLinkedAccount(authService: AuthenticationService) {
  if (authService.getUser()?.is_patreon || authService.getUser()?.is_youtube_member) {
    return true;
  }

  return false;
}

export function getErrorMessage(code: string) {
  return ERROR_MESSAGES[code] ?? "Unbekannter Fehler!";
}
